import { ark } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import { spinner } from '@terra/ui-styled-system';
import type { ComponentProps } from '@terra/ui-styled-system';

export type SpinnerProps = ComponentProps<typeof Spinner>;
export const Spinner = styled(ark.div, spinner);
